import axios from "axios"
import router from '../router/index'
import { ElMessage } from 'element-plus'
import cache from '../utils/cache'
import util from '../utils/util'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    'Content-Language': util.language()
  },
})
api.interceptors.request.use(request => {
  const user = cache.getObject(cache.keys.loginUser)
  if (user && user.token) {
    request.headers.Token = user.token
  }
  request.data = request.data || {}
  return request
})
let P000002 = false
let P000003 = false
api.interceptors.response.use(res => {
  if (res.status != 200 || !res.data) {
    // ElMessage.error('网络连接异常，请稍后再试')
    ElMessage.error(JSON.stringify(res))
    console.error(res)
    throw res
  }
  if (res.data.code != 'S000001') {
    if (res.data && res.data.code == 'P000001') {// 参数错误
      ElMessage.warning(res.data.message || util.language('参数错误', 'Parameter error'))
      throw res
    }
    if (res.data && res.data.code == 'P000002') {// 登录失效
      cache.setObject(cache.keys.loginUser, null)
      if (P000002 == false) {
        P000002 = true
        ElMessage.warning(util.language('登录超时，请重新登录', 'Login timeout or not logged, please login again'))
        router.push('/login')
        setTimeout(() => {
          P000002 = false
        }, 1000)
      }
      throw res
    }
    if (res.data && res.data.code == 'P000003') {// 无权限
      if (P000003 == false) {
        P000003 = true
        ElMessage.warning(util.language('无权限', 'No permission'))
        setTimeout(() => {
          P000003 = false
        }, 1000)
      }
      throw res
    }
    if (res.data && res.data.message) {
      ElMessage.error(res.data.message)
      throw res
    }
    // ElMessage.error('网络连接异常，请稍后再试')
    ElMessage.error(JSON.stringify(res))
    console.error(res)
    throw res
  }
  return res.data.data
})

api.baseURL = () => { return '/api' }
api.tokenHeader = () => {
  const result = {}
  const user = cache.getObject(cache.keys.loginUser)
  if (user && user.token) {
    result.Token = user.token
  }
  return result
}
export default api